import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypeTitle: {
		id: 'issue-line-card-issue-type.issue-type-title',
		defaultMessage: 'Issue type: {issueTypeName}',
		description: 'A text title for the issue type icon, mainly for accessibility purposes.',
	},
	issueTypeTitleIssueTerminologyRefreshM4: {
		id: 'issue-line-card-issue-type.issue-type-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work type: {issueTypeName}',
		description: 'A text title for the issue type icon, mainly for accessibility purposes.',
	},
});
